import {RolEntity, UsuarioEntity} from '../../CoreModule/entities/usuario.entity';
import {UsuarioServices} from '../../CoreModule/services/usuario.services';
import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {TiendaEntity} from '../../CoreModule/entities/tienda.entity';
import {TiendaServices} from '../../CoreModule/services/tienda.services';
import {RolServices} from '../../CoreModule/services/rol.services';
import {RegionalServices} from '../../CoreModule/services/regional.services';
import {RegionalEntity} from '../../CoreModule/entities/regional.entity';
import {NgxSpinnerService} from 'ngx-spinner';

@Component({
  selector: 'usuarios-list',
  templateUrl: '../templates/usuario/usuario.list.template.html'
})
export class UsuariosCrudComponent implements OnInit {
  public usuarios: UsuarioEntity[] = [];

  constructor(private us: UsuarioServices) {
  }

  ngOnInit() {

    this.us.getAllUser().subscribe(d => {
      this.usuarios = d.data.usuarios;
    });

  }
}

@Component({
  selector: 'usuarios-new',
  templateUrl: '../templates/usuario/usuario.new.template.html'
})
export class UsuarioNewComponent implements OnInit {

  public usuario: UsuarioEntity = new UsuarioEntity();
  public tiendas: TiendaEntity[] = [];
  public roles: RolEntity[] = [];
  public tiendasSelect: TiendaEntity[] = [];
  public regionales: RegionalEntity[] = [];
  public confirmarContrasena: string = '';

  constructor(private us: UsuarioServices, private ts: TiendaServices, private rs: RolServices, private router: Router, private regs: RegionalServices, private spinner: NgxSpinnerService) {

    this.usuario.rol = new RolEntity();

  }

  ngOnInit(): void {
    this.ts.getAllTiendas().subscribe(d => {
      this.tiendas = d.data.tiendas;
    });

    this.regs.getAllRegional().subscribe(d => {
      this.regionales = d.data.regionales;
    });

    this.rs.getRoles().subscribe(d => {
      this.roles = d.data.rols;
    });
  }

  guardarUsuario() {
    this.spinner.show();
    let tiendasID: number[] = [];
    this.tiendasSelect.map(t => tiendasID.push(+t));
    this.us.createUser(this.usuario, tiendasID).subscribe(d => {
      this.spinner.hide();
      alert('Nuevo usuario creado exitosamente');
      this.router.navigate(['/admin/usuarios']);
    });
  }
}

@Component({
  selector: 'usuarios-edit',
  templateUrl: '../templates/usuario/usuario.edit.template.html'
})
export class UsuarioEditComponent implements OnInit {

  public usuario: UsuarioEntity;
  public tiendas: TiendaEntity[] = [];
  public tiendasSelect: any[] = [];
  public roles: RolEntity[] = [];
  public regionales: RegionalEntity[] = [];
  public confirmarContrasena: string = '';

  constructor(private us: UsuarioServices, private ts: TiendaServices, private activeRouter: ActivatedRoute, private rs: RolServices, private regs: RegionalServices, private spinner: NgxSpinnerService) {
  }

  ngOnInit() {
    let id = +this.activeRouter.snapshot.params.id;
    this.spinner.show();
    this.us.getUser(id).subscribe(d => {
      console.log(d);
      this.usuario = d.data.usuario;
      this.usuario.contrasena = '';
      this.usuario.tiendas.map((t: any) => {
        this.tiendasSelect.push(t.id);
      });
      this.spinner.hide();
    });

    this.rs.getRoles().subscribe(d => {

      this.roles = d.data.rols;
    });

    this.regs.getAllRegional().subscribe(d => {
      this.regionales = d.data.regionales;
    });
    //
    this.ts.getAllTiendas().subscribe(d => {
      this.tiendas = d.data.tiendas;
    });
  }


  guardarUsuario() {
    this.spinner.show();
    let tiendasID: number[] = [];
    this.tiendasSelect.map(t => tiendasID.push(+t));
    this.us.updateUser(this.usuario, tiendasID).subscribe(d => {
      this.spinner.hide();
      alert('Actualizacion de usuario exitosa');
    });
  }

  cambiarContrasena() {
    if (this.usuario.contrasena == this.confirmarContrasena) {
      this.spinner.show();
      let tiendasID: number[] = [];
      this.tiendasSelect.map(t => tiendasID.push(+t));
      this.us.updateUser(this.usuario, tiendasID).subscribe(d => {
        this.spinner.hide();
        alert('Actualizacion de usuario exitosa');
      });
    } else {
      alert('Las contraseñas no coinciden');
    }
  }

}

